import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useIsAuthenticated } from '@/features/auth/session';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const authed = useIsAuthenticated();
  const location = useLocation();
  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
